/* Labella: presentation only. Native variant, inventory, filter and cart code stays in charge. */
(() => {
  'use strict';
  if (window.LabellaDesignPolish) return;

  const values = value => [...new Set((Array.isArray(value) ? value : [value])
    .filter(v => typeof v === 'string' && v.trim()).map(v => v.trim()))];
  const fold = text => String(text || '').toLocaleLowerCase('tr-TR');
  function cardLabels(data) {
    const title = String(data.title || '');
    if (data.clear && [6, 30].includes(data.packSize) && data.clearTitle && data.clearPeriod) {
      return { title: data.clearTitle, badges: [data.clearPeriod, `${data.packSize} lens`, 'Numaralı'] };
    }
    const series = values(data.series);
    const matched = title.match(/\b(Premium|Milano|Real|Pixie|Exclusive)\b/i);
    const shortTitle = series.length === 1 ? series[0] : !series.length && matched ? matched[0] : title;
    let periods = values(data.period).map(p => /^3\s*ay$/i.test(p) ? '3 Aylık' : p);
    if (!periods.length) {
      const text = fold(title);
      if (/3\s*aylık/.test(text)) periods = ['3 Aylık'];
      else if (text.includes('yıllık')) periods = ['Yıllık'];
      else if (text.includes('aylık')) periods = ['Aylık'];
    }
    let kinds = values(data.kind);
    if (!kinds.length) {
      const text = fold(title);
      if (text.includes('numarasız')) kinds = ['Numarasız'];
      else if (text.includes('numaralı')) kinds = ['Numaralı'];
    }
    return { title: shortTitle, badges: [periods.join(' / '), kinds.join(' / ')].filter(Boolean) };
  }
  function formatMoney(minor, currency = 'TRY') {
    if (typeof minor !== 'number' || !Number.isFinite(minor) || minor < 0) return null;
    if (currency === 'TRY') return new Intl.NumberFormat('tr-TR', {
      minimumFractionDigits: 2, maximumFractionDigits: 2
    }).format(minor / 100) + ' ₺';
    try { return new Intl.NumberFormat('tr-TR', { style: 'currency', currency }).format(minor / 100); }
    catch (_) { return null; }
  }
  function normalizePriceText(text, currency = 'TRY') {
    if (currency !== 'TRY') return text;
    const amount = '(?:\\d{1,3}(?:\\.\\d{3})+|\\d+),\\d{2}';
    return text.replace(new RegExp('₺[\\s\\u00a0]*(' + amount + ')(?![\\d,.])', 'g'), '$1 ₺')
      .replace(new RegExp('(' + amount + ')[\\s\\u00a0]*(?:TL|TRY)\\b', 'g'), '$1 ₺');
  }
  function manualPriceText(text, data, currency = 'TRY') {
    const amount = '(?:\\d{1,3}(?:[.\\s]\\d{3})+|\\d+)(?:[.,]\\d{2})?';
    const token = new RegExp('₺\\s*' + amount + '|' + amount + '\\s*(?:TL|TRY)\\b|' + amount + '\\s*₺', 'i');
    const price = !data.missing && !data.priceVaries ? formatMoney(data.price, currency) : null;
    return text.replace(token, price || 'Fiyatı inceleyin');
  }
  window.LabellaDesignPolish = { cardLabels, formatMoney, normalizePriceText, manualPriceText };
  const configNode = document.getElementById('lb-design-config');
  if (!configNode) return;
  let config;
  try { config = JSON.parse(configNode.textContent); } catch (_) { return; }
  const currency = config.currency || 'TRY';
  const processed = new WeakMap();
  const descriptions = new WeakSet();
  const titleStates = new WeakMap();
  let detailData = null;
  const textOf = el => (el.textContent || '').trim();
  function read(script) {
    try { return JSON.parse(script.textContent); } catch (_) { return null; }
  }
  function make(tag, className, text) {
    const node = document.createElement(tag);
    node.className = className;
    if (text !== undefined) node.textContent = text;
    return node;
  }
  function viewportWidth() {
    const width = document.documentElement.clientWidth;
    if (!width) return;
    const value = width + 'px';
    document.querySelectorAll('.lb-benefits').forEach(bar => {
      if (bar.style.getPropertyValue('--lb-dp-viewport') !== value) {
        bar.style.setProperty('--lb-dp-viewport', value);
      }
      if (!bar.classList.contains('lb-dp-viewport')) bar.classList.add('lb-dp-viewport');
    });
  }
  function selectedColor(info) {
    const helper = info.querySelector('lb-lens-picker[data-ready]');
    const pressed = helper?.querySelector('[data-lb-color][aria-pressed="true"]');
    if (pressed) return textOf(pressed.querySelector('span') || pressed);
    for (const field of info.querySelectorAll('variant-selects .product-form__input')) {
      const label = field.querySelector('legend, label');
      const name = fold(label?.textContent.split(':')[0].trim());
      if (!['renk', 'color', 'colour'].includes(name)) continue;
      const select = field.querySelector('select');
      if (select) return select.value.trim();
      const radio = field.querySelector('input:checked');
      if (radio) return radio.value.trim();
      const selected = field.querySelector('[data-selected-value]');
      if (selected) return textOf(selected);
    }
    return '';
  }
  function productTitles() {
    const data = detailData;
    if (!data?.colored || data.missing) return;
    const labels = cardLabels(data);
    // Only series products with a meaningful shorter name receive this mobile treatment.
    if (!labels.title || labels.title === data.title) return;
    document.querySelectorAll('product-info[id^="MainProduct-"]').forEach(info => {
      if (info.dataset.productId && String(info.dataset.productId) !== String(data.id)) return;
      const heading = info.querySelector('.product__title > h1');
      if (!heading) return;
      let state = titleStates.get(heading);
      if (!state) {
        if (textOf(heading) !== data.title) return;
        const original = make('span', 'lb-dp-original-title');
        original.append(...heading.childNodes);
        const visual = make('span', 'lb-dp-mobile-title', /serisi$/i.test(labels.title) ? labels.title : labels.title + ' Serisi');
        visual.setAttribute('aria-hidden', 'true');
        heading.append(original, visual);
        heading.classList.add('lb-dp-compact-title');
        const meta = make('div', 'lb-dp-mobile-meta');
        if (labels.badges.length) meta.append(make('p', 'lb-dp-mobile-subtitle', labels.badges.join(' · ')));
        const color = make('p', 'lb-dp-selected-color');
        color.append(document.createTextNode('Seçilen renk: '));
        const value = document.createElement('strong');
        color.append(value);
        color.hidden = true;
        meta.append(color);
        heading.after(meta);
        state = { color, value };
        titleStates.set(heading, state);
      }
      const color = selectedColor(info);
      if (state.value.textContent !== color) state.value.textContent = color;
      if (state.color.hidden !== !color) state.color.hidden = !color;
    });
  }
  function card(script, data) {
    if ((!data.colored && !data.clear) || data.missing) return;
    const item = script.closest('.grid__item, li');
    const wrapper = item ? item.querySelector('.card-wrapper') :
      script.previousElementSibling?.matches('.card-wrapper') ? script.previousElementSibling : null;
    const info = wrapper?.querySelector(':scope > .card > .card__content .card__information');
    const heading = info?.querySelector('.card__heading');
    const link = heading?.querySelector('a');
    if (!link || !data.title) return;
    const labels = cardLabels(data);
    const badgeLabels = (link.getAttribute('aria-labelledby') || '').split(/\s+/)
      .filter(id => id && id !== link.id).map(id => document.getElementById(id))
      .filter(Boolean).map(textOf).filter(Boolean);
    link.textContent = labels.title;
    link.title = data.title;
    link.setAttribute('aria-label', [data.title, ...badgeLabels].join(' — '));
    link.removeAttribute('aria-labelledby');
    info.querySelectorAll('.lb-dp-badges, .lb-dp-previews').forEach(el => el.remove());
    if (labels.badges.length) {
      const badges = make('div', 'lb-dp-badges');
      labels.badges.forEach(text => badges.append(make('span', 'lb-dp-badge', text)));
      heading.after(badges);
    }
    if (Number.isInteger(data.colorCount) && data.colorCount > 0) {
      const previews = make('div', 'lb-dp-previews');
      (Array.isArray(data.previews) ? data.previews : []).slice(0, 3).forEach(color => {
        if (!color || typeof color.image !== 'string' || !/^(https?:)?\/\//.test(color.image)) return;
        const img = document.createElement('img');
        img.src = color.image;
        img.alt = '';
        img.setAttribute('aria-hidden', 'true');
        img.loading = 'lazy';
        img.width = 30; img.height = 30;
        previews.append(img);
      });
      previews.append(make('span', 'lb-dp-color-count', data.colorCount + ' renk'));
      info.append(previews);
    }
    wrapper.classList.add('lb-dp-card');
    wrapper.classList.toggle('lb-dp-clear-card', Boolean(data.clear));
  }
  function ownUrl(value) {
    try {
      const url = new URL(value, location.href);
      const domain = String(config.shopDomain || '').replace(/^www\./, '');
      return url.origin === location.origin || url.hostname.replace(/^www\./, '') === domain ? url : null;
    } catch (_) { return null; }
  }
  function home(data) {
    const canonical = data.url ? ownUrl(data.url) : null;
    const paths = [...values(data.aliases), data.url].filter(Boolean)
      .map(value => ownUrl(value)?.pathname).filter(Boolean);
    document.querySelectorAll('.multicolumn-card__info').forEach(info => {
      const link = [...info.querySelectorAll('a[href]')].find(a => {
        const url = ownUrl(a.getAttribute('href'));
        return url && paths.includes(url.pathname);
      });
      if (!link) return;
      if (canonical) {
        const old = ownUrl(link.getAttribute('href'));
        const next = canonical.pathname + old.search + old.hash;
        if (link.getAttribute('href') !== next) link.setAttribute('href', next);
      }
      info.querySelectorAll('.rte p').forEach(p => {
        if (p.querySelector('a, button, input')) return;
        const text = manualPriceText(p.textContent, data, currency);
        if (p.textContent === text) return;
        p.textContent = text;
        p.classList.add('lb-dp-home-price');
      });
    });
  }
  function accordion(title, nodes, heading) {
    const details = make('details', 'lb-dp-accordion');
    const summary = document.createElement('summary');
    summary.append(heading || document.createTextNode(title));
    const icon = make('span', 'lb-dp-accordion-icon');
    icon.setAttribute('aria-hidden', 'true');
    summary.append(icon);
    const body = make('div', 'lb-dp-accordion-body');
    body.append(...nodes);
    details.append(summary, body);
    return details;
  }
  function description(root) {
    if (descriptions.has(root)) return;
    descriptions.add(root);
    if (root.querySelector('details, form, input, select, textarea, button, script, iframe, [onclick]')) return;
    let content = root;
    while (content.children.length === 1 && content.firstElementChild.tagName === 'DIV' &&
      [...content.childNodes].every(n => n === content.firstElementChild || !n.textContent.trim())) {
      content = content.firstElementChild;
    }
    if (!textOf(content)) return;
    const original = [...content.childNodes];
    try {
      const groups = [];
      let group = { title: 'Ürün hakkında', nodes: [], heading: null };
      original.forEach(node => {
        if (node.nodeType === 1 && /^(H2|H3)$/.test(node.tagName) && textOf(node)) {
          if (group.heading || group.nodes.some(n => n.textContent.trim() || n.nodeType === 1 && n.querySelector('img'))) groups.push(group);
          group = { title: textOf(node), nodes: [], heading: node };
        } else group.nodes.push(node);
      });
      if (group.heading || group.nodes.some(n => n.textContent.trim())) groups.push(group);
      if (!groups.length) return;
      const fragment = document.createDocumentFragment();
      groups.forEach(g => fragment.append(accordion(g.title, g.nodes, g.heading)));
      if (!groups.some(g => /kargo|iade|teslimat/i.test(g.title))) {
        const links = make('div', 'lb-dp-policy-links');
        [[config.shippingUrl, 'Kargo ve teslimat koşulları'], [config.refundUrl, 'İade koşulları']].forEach(([url, label]) => {
          if (!url || !ownUrl(url)) return;
          const a = document.createElement('a'); a.href = url; a.textContent = label; links.append(a);
        });
        if (links.children.length) fragment.append(accordion('Kargo ve iade', [links]));
      }
      content.replaceChildren(fragment);
      content.classList.add('lb-dp-description-inner');
      root.classList.add('lb-dp-description');
    } catch (_) { content.replaceChildren(...original); }
  }
  const priceSelector = '#MainContent .price-item--regular, #MainContent .price-item--sale, .lb-bsc__offer small, .lb-summary > strong, .lb-ux-amount';
  function prices() {
    document.querySelectorAll(priceSelector).forEach(el => {
      const walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT);
      let node;
      while ((node = walker.nextNode())) {
        const value = normalizePriceText(node.nodeValue, currency);
        if (value !== node.nodeValue) node.nodeValue = value;
      }
    });
  }
  function refresh() {
    document.querySelectorAll('script[data-lb-design-product]').forEach(script => {
      if (processed.get(script) === script.textContent) return;
      const data = read(script);
      if (!data) return;
      processed.set(script, script.textContent);
      if (script.dataset.lbDesignProduct === 'card') card(script, data);
      else if (script.dataset.lbDesignProduct === 'home') home(data);
      else if (script.dataset.lbDesignProduct === 'detail') detailData = data;
    });
    viewportWidth();
    productTitles();
    document.querySelectorAll('product-info[id^="MainProduct-"] .product__description').forEach(description);
    prices();
  }
  let pending = false;
  function schedule() {
    if (pending) return;
    pending = true;
    requestAnimationFrame(() => { pending = false; refresh(); });
  }
  refresh();
  new MutationObserver(schedule).observe(document.body, { childList: true, characterData: true, subtree: true,
    attributes: true, attributeFilter: ['aria-pressed', 'checked', 'selected'] });
  document.addEventListener('change', schedule);
  window.addEventListener('resize', schedule, { passive: true });
  if ('ResizeObserver' in window) new ResizeObserver(schedule).observe(document.documentElement);
  document.addEventListener('shopify:section:load', schedule);
})();
